import React, { useState } from 'react';

import { Box, Grid } from "@mui/material";
import { BannerGrid, Section1, Section2, Section3, FormGrid } from "./Sobre.js";

import { Footer } from '../../components/Footer/Footer.jsx';
import { Header } from '../../components/Header/Header.jsx';
import { Form } from '../../components/Form/Form.jsx';


import Circle from '../../assets/cangoo-banner-elemento.png'
import Section1Img from '../../assets/cangoo-sobre-img-inicial.png'
import Section2Img from '../../assets/cangoo-sobre-mascote.png'

import Icon1off from '../../assets/cangoo-sobre-missao-off.png'
import Icon1on from '../../assets/cangoo-sobre-missao-on.png'

import Icon2off from '../../assets/cangoo-sobre-visao-off.png'
import Icon2on from '../../assets/cangoo-sobre-visao-on.png'

import Icon3off from '../../assets/cangoo-sobre-valores-off.png'
import Icon3on from '../../assets/cangoo-sobre-valores-on.png'




export function Sobre() {
  const [isIcon1Hovered, setIsIcon1Hovered] = useState(false);
  const [isIcon2Hovered, setIsIcon2Hovered] = useState(false);
  const [isIcon3Hovered, setIsIcon3Hovered] = useState(false);


  const handleMouseOverIcon1 = () => {
    setIsIcon1Hovered(true);
  };

const handleMouseOutIcon1 = () => {
  setIsIcon1Hovered(false);
  };
  

  const handleMouseOverIcon2 = () => {
    setIsIcon2Hovered(true);
  };

  const handleMouseOutIcon2 = () => {
    setIsIcon2Hovered(false);
  };

  const handleMouseOverIcon3 = () => {
    setIsIcon3Hovered(true);
  };

  const handleMouseOutIcon3 = () => {
    setIsIcon3Hovered(false);
  };

    return (
      <>
      <Header/>

      <BannerGrid container>
        <Grid item xs={12} sm={12} md={12}>
<div className="title">
  <h1>Sobre nós</h1>
  <img src={Circle} alt="" />
</div>
        </Grid>
      </BannerGrid>

      <Section1 container>
      <Grid className='sideA' item xs={12} sm={12} md={6} lg={6} xl={7}>
<h1>Somos a</h1>
<h2>Cangoo</h2>
<p>
A <span>Cangoo Express</span> é uma empresa que realiza transporte
de mercadorias, com foco maior no ramo aéreo, porém,
oferecemos envios rodoviários também, para que possamos
ser o que mais amamos: a solução dos problemas logísticos
das empresas.<br/><br/>

Nosso maior diferencial sempre será prestar o melhor
atendimento possível, dar suporte, resolver todas as
pequenas burocracias e eventuais problemas que possam
vir a surgir, lembrando que contamos com uma equipe
com vasto conhecimento na aérea, com preparo e muita
vontade para fazer nosso trabalho da melhor forma
possível.<br/><br/>

Atuamos em todo território nacional, tanto para enviar sua
mercadoria, quanto para trazê-la até você, quando falamos
isso, é porque dispomos de mais de 60 bases operacionais
para atender toda a demanda.<br/><br/>

<span className='yellow'>
Nós realmente nos preocupamos com você, com sua
carga e com o seu cliente.
</span>
</p>
      </Grid>

      <Grid className='sideB' item xs={12} sm={12} md={6} lg={6} xl={5}>
      <img src={Section1Img} alt="" />
</Grid>
      </Section1>
     


      <Section2 container>
      <Grid className='sideA' item xs={12} sm={12} md={5} lg={5} xl={5}>
      <img src={Section2Img} alt="" />

      </Grid>

      <Grid className='sideB' item xs={12} sm={12} md={7} lg={7} xl={7}>
<h1>
Você sabe por que<br/>
nosso mascote é um<br/>
</h1>
<h1 className='yellow'>canguru?</h1>

<p>
Com certeza você já viu a mamãe canguru levando seu
filho em proteção para qualquer lugar, correto?<br/><br/>

<span>E foi assim que surgiu a Cangoo:</span> inspirados pelo
acolhimento e cuidado que os cangurus têm com seus
filhotes, abordamos as cargas de nossos clientes com o
mesmo apresso. Seja com um controle de qualidade
com a embalagem no aceite, com um rastreio constante
de sua carga em todo o trajeto, até a chegada no destino
final.<br/><br/>

<span>Uma curiosidade:</span> Você sabia que uma das espécies de
canguru, ao nascer, apresenta o tamanho de uma
abelha? Isso nos fez relembrar que cabe a mãe deste
filhote, zelar, cuidar e protegê-lo. E assim é a visão da
Cangoo: cuidar e <span className='yellow'>proteger não somente as cargas que
transportamos,</span> mas nossos clientes, seus interesses e
tudo que os rodeia e nos cerca, afinal, o crescimento dos
nossos clientes, é o nosso também.
</p>
</Grid>
      </Section2>



<Section3 container>
<Grid className='icons-top' xs={12} item sm={12} md={4} lg={4} xl={4}>
<img onMouseOver={handleMouseOverIcon1} onMouseOut={handleMouseOutIcon1} src={isIcon1Hovered ? Icon1on : Icon1off} alt="" />
</Grid>

<Grid className='icons-top' xs={12} item sm={12} md={4} lg={4} xl={4}>
<img onMouseOver={handleMouseOverIcon2} onMouseOut={handleMouseOutIcon2} src={isIcon2Hovered ? Icon2on : Icon2off} alt="" />
</Grid>

<Grid className='icons-top' xs={12} item sm={12} md={4} lg={4} xl={4}>
<img onMouseOver={handleMouseOverIcon3} onMouseOut={handleMouseOutIcon3} src={isIcon3Hovered ? Icon3on : Icon3off} alt="" />
</Grid>

<Grid className='sideA' onMouseOver={handleMouseOverIcon1} onMouseOut={handleMouseOutIcon1} item xs={12} sm={12} md={4} lg={4} xl={4}>
<img className='icons-bottom hide' onMouseOver={handleMouseOverIcon1} onMouseOut={handleMouseOutIcon1} src={isIcon1Hovered ? Icon1on : Icon1off} alt="" />

<h1>Missão</h1>
<p>
Não apenas realizar entregas e
coletas em todo território
nacional, mas ter um olhar
humanizado sobre o segmento,
no sentido de entender e apoiar
nossos clientes a fim de que todos
possam prosperar mutuamente.
</p>
</Grid>

<Grid className='sideB' onMouseOver={handleMouseOverIcon2} onMouseOut={handleMouseOutIcon2} item xs={12} sm={12} md={4} lg={4} xl={4}>
<img className='icons-bottom hide' onMouseOver={handleMouseOverIcon2} onMouseOut={handleMouseOutIcon2} src={isIcon2Hovered ? Icon2on : Icon2off} alt="" />

<h1>Visão</h1>
<p>
Ser referência em prestar suporte,
atendimento e excelência em
nossos serviços.
</p>
</Grid>

<Grid className='sideC' onMouseOver={handleMouseOverIcon3} onMouseOut={handleMouseOutIcon3} item xs={12} sm={12} md={4} lg={4} xl={4}>
<img className='icons-bottom hide' onMouseOver={handleMouseOverIcon3} onMouseOut={handleMouseOutIcon3} src={isIcon3Hovered ? Icon3on : Icon3off} alt="" />

<h1>Valores</h1>
<p>
Ser íntegro em todos aspectos
e processos;<br/><br/>

Possuir ética, respeito e
comprometimento em todas
as ações;<br/><br/>

Ter um olhar humano sobre
tudo e todos;<br/><br/>

Ter zelo não apenas pelas
cargas, mas também por
todos nossos valores. 

</p>
</Grid>

<Grid className='bottom' item xs={12} sm={12} md={12} lg={12} xl={2}></Grid>
</Section3>


<FormGrid container>
<Grid className='text' item xs={12}>
<h1>Ficou com alguma dúvida?</h1>
<p>
Preencha o formulário abaixo para falar com nossa equipe.
</p>
</Grid>

<Grid className='form' item xs={12} sm={10} md={7} lg={6} xl={5}>
<Form pagina={"Sobre Nós"}/>
</Grid>
</FormGrid>

      <Footer/>

      </>
    )
  }